<template>
    <div class="app">




        <b-row align-v="stretch" v-b-scrollspy>

            <b-col md="4">

                <!-- <b-card v-for="menu in menus" :key="menu.menuid">
                        <router-link :to="menu.link +  '?id='+menu.menuid+'&desc=' + menu.menudesc_lao">
                            <b-icon :icon="menu.icon" font-scale="4"></b-icon>
                            <p>{{ menu.menudesc_lao }}</p>
                        </router-link>
                    </b-card> -->

              

                <div v-for="menu in menus" :key="menu.menuid" >
                    <b-card no-body  v-show="menu.login" header-tag="header"  class="m-2" v-b-toggle="menu.menuid"
                        bg-variant="primary" text-variant="white">
                        <template #header>
                            <h6 class="mb-0"><b-icon :icon="menu.icon"></b-icon> {{ menu.menudesc_lao }}</h6>
                        </template>

                        <b-collapse  :id="menu.menuid"  visible
                            role="tabpanel">
                            <b-list-group flush v-for="smenu in menu.submenu" :key="smenu.menuid" :id="menu.menuid">

                                <b-list-group-item  v-show="smenu.login" href="#"
                                    :to="smenu.link + '?id=' + smenu.menuid + '&desc=' + smenu.menudesc_lao"
                                    class="pl-5"> 
                                    <b-icon :icon="smenu.icon"></b-icon>
                                    {{ smenu.menudesc_lao}} </b-list-group-item>

                            </b-list-group>
                        </b-collapse>

                    </b-card>
                </div>



            </b-col>
            <b-col>
                <router-view />
            </b-col>
        </b-row>


        <b-navbar toggleable="lg" type="light" variant="light"  fixed="bottom"     >
         <div>
            ຊືຜູ້ໃຊ້: {{ user.username }} 
         </div>
     </b-navbar>

    </div>
</template>

<script>
import axios from "axios";
export default {
    // watch: {
    //     getsubmenu(parent_id) {
    //         axios.get(this.$store.getters.getBaseUrl + "/getMenu/" + parent_id+"?level_id="+this.user.user_level).then((rep) => {
    //             //this.submenu = rep.data;
    //             this.submenu.push(rep.data)
    //         });
    //     }
    // },
    name: "Home",
    data() {
        return {
            user:[],
            menus: [],
            submenu: []
            
        };
    },
    mounted() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
         axios.get(this.$store.getters.getBaseUrl + "/getMenu/0000?"+"level_id="+this.user.user_level,
         {
            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
         }
         ).then((rep) => {
             this.menus = rep.data;
         });
    },
    methods: {
        exit() {
            localStorage.removeItem("Login");
            this.$router.push("/login");
        },

    },
};
</script>

<style scoped>
.text-md-center {
    padding: 150px;
}

.icon {
    background-color: white;
}

.menu:link {
    background-color: yellow;
}

.menu:visited {
    background-color: cyan;
}

.menu:hover {
    background-color: lightgreen;
}

.menu:active {
    background-color: hotpink;
}

.content {
    padding-top: 50px;
}

.title {
    color: white;
    font-size: 1.5rem;
}
</style>
     
 